export enum LotStatusEnum {
    WAITING = 1,
    PRODUCTION = 2,
    PARTIAL_DELIVERY = 3,
    FULL_DELIVERY = 4,
    CLOSED = 5,
    CANCELED = 6,
}
